/**
 * Weather API.
 *
 * Thin wrapper around the shared api client. The backend proxies Open-Meteo
 * and returns a shaped { current, today, forecast } payload; saving a
 * signed-in user's location goes through the existing PATCH /api/auth/me
 * (see api/profile.js → updateProfile).
 */

import { api } from './client.js';

export const getWeather = (lat, lon) =>
  api.get(`/api/weather?lat=${lat}&lon=${lon}`);

export const geocodeWeather = (q) =>
  api.get(`/api/weather/geocode?q=${encodeURIComponent(q)}`);
